import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import StatusTransitionsService from '../../components/services/StatusTransitionsService';

const useStatusTransitionsService = () => {
  return useMemo(() => new StatusTransitionsService(new ApiCalls()), []);
};

export default useStatusTransitionsService;
